import { GenericObject } from '@cp/src/types/CommonConstans';
import { Dispatch } from 'react';
import { logOut } from '@cp/pages/auth/AuthActions';
import logoutFromSlash from '@cp/utils/logoutFromSlash';
import logoutFromAmeyo from '@cp/utils/logoutFromAmeyo';
import { toast } from '@primitives/Toast';

enum PLATFORMS {
  ALL = 'ALL',
  SLASH = 'SLASH',
  AMEYO = 'EXTENSION'
}
function stateResetterProcessor(payload: GenericObject, currentAgentReferenceId: string) {
  const paramsInObject = payload.params;

  if (paramsInObject.agentReferenceId === currentAgentReferenceId) {
    if (paramsInObject.platform === PLATFORMS.ALL) {
      toast.info('Logging you out from all Longhorn');
      logOut();
    }
    if (paramsInObject.platform === PLATFORMS.SLASH) {
      toast.info('Logging you out from slash please re-open again');
      logoutFromSlash();
    }
    if (paramsInObject.platform === PLATFORMS.AMEYO) {
      toast.info('Logging you out from ameyo it will re-open automatically');
      logoutFromAmeyo();
    }
  }
}

export default stateResetterProcessor;
